import React from "react";

import { EquationRenderer } from "./equation-renderer";

const HTML_ENTITIES: Record<string, string> = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#34;": '"',
  "&#39;": "'",
  "&apos;": "'",
  "&nbsp;": " ",
};

/**
 * OAC HTML은 LaTeX 원문을 HTML 안전을 위해 엔티티로 이스케이프해 담는다 —
 * 행렬/정렬 환경의 열 구분자 `&`는 `&amp;`로 온다. MathJax에는 raw LaTeX가
 * 필요하므로, html-react-parser를 거치지 않고 문자열에서 직접 뽑아낸 수식은
 * 여기서 엔티티를 되돌려야 한다(안 하면 `&amp;`가 그대로 남아 `amp;`로 렌더된다).
 * map으로 한 번에 치환하므로 `&amp;lt;`(리터럴 `&lt;`)도 이중 디코드 없이 보존된다.
 */
function decodeHtmlEntities(input: string): string {
  return input.replace(
    /&(?:amp|lt|gt|quot|apos|nbsp|#34|#39);/g,
    entity => HTML_ENTITIES[entity] ?? entity,
  );
}

/**
 * equation category용 HTML 문자열을 LaTeX 수식으로 파싱하여 렌더링하는 helper
 */
export function renderEquation(html: string): React.ReactElement {
  const matches = html.match(/\$\$(.*?)\$\$/);
  const rawTex = matches ? matches[1] : html.replaceAll("$$", "");
  return <EquationRenderer tex={decodeHtmlEntities(rawTex)} />;
}
